import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import GoogleButton from 'react-google-button'

import settings from '../../settings'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(5),
  },
}))

const googleLogin = () => {
  document.location = settings.googleLogin
}

const Login = ({

}) => {

  const classes = useStyles()

  return (
    <div className={ classes.root }>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Paper className={ classes.paper }>
            <GoogleButton
              type="dark"
              onClick={ googleLogin }
            />
          </Paper>
        </Grid>
      </Grid>
    </div>
  )
}

export default Login